import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id 133BA980-E797-4DB3-9C92-F59AC3DB3399
 * name archive-arrow-down-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-arrow-down-outline.svg
 * tags
 */
export const ArchiveArrowDownOutlineIcon = createSvgIcon(<><path d="M20 21H4V10H6V19H18V10H20V21M3 3H21V9H3V3M5 5V7H19V5M10.5 11V14H8L12 18L16 14H13.5V11" /></>, 'ArchiveArrowDownOutlineIcon');
export default ArchiveArrowDownOutlineIcon